import api from './api';
import { ChatRequest, ChatResponse, Conversation, VocabularyCard } from '../types';

export const chatService = {
  async sendMessage(request: ChatRequest): Promise<ChatResponse> {
    const response = await api.post('/chat/send', request);
    return response.data;
  },

  async getConversations(): Promise<Conversation[]> {
    const response = await api.get('/chat/conversations');
    return response.data;
  },

  async getConversation(id: number): Promise<Conversation> {
    const response = await api.get(`/chat/conversations/${id}`);
    return response.data;
  },

  async deleteConversation(id: number): Promise<void> {
    await api.delete(`/chat/conversations/${id}`);
  },

  async extractVocabulary(conversationId: number): Promise<VocabularyCard[]> {
    const response = await api.post(`/chat/conversations/${conversationId}/extract-vocabulary`);
    return response.data;
  }
};
